import { useMemo, useCallback } from 'react';
import { EventInfo } from '@quickService/DashboardEventBriefInfo';
import { Items as ErrorInfo } from '@quickService/DashboardEventGetPublishErrorList';
import { useRouter } from 'next/router';
import dataReport from '@utils/data-report';
import { useHostRegistrationUrl } from '@hooks/useRainbowConfig';
import { openNewPage } from '@utils/open-new-pgae';

export const ACTIVITY_STATUS_MAP = [
  { text: '未发布', type: undefined, className: '' },
  { text: '已发布', type: 'success', className: '' },
  { text: '审核中', type: 'warning', className: '' },
  { text: '发布失败', type: 'error', className: '' },
  { text: '修改审核中', type: 'warning', className: 'ma-activity-status-xs' },
  { text: '修改失败', type: 'error', className: '' },
] as const;

const useEventDetailHooks = (eventInfo: EventInfo, errorInfo?: ErrorInfo) => {
  const router = useRouter();
  const eventId = String(router.query.eventid);
  const registrationUrl = useHostRegistrationUrl(eventInfo?.host_id);
  const status = useMemo(() => {
    if ((eventInfo.status === 3 || eventInfo.status === 5) && eventInfo?.items_sort !== 2) {
      return {
        ...ACTIVITY_STATUS_MAP[eventInfo.status],
        text: eventInfo.status === 3 ? '审核不通过' : '修改审核不通过',
        className:
          eventInfo.status === 3 ? 'ma-activity-status-xs' : 'ma-activity-status-xs new-line',
      };
    }
    return ACTIVITY_STATUS_MAP[eventInfo.status || 0];
  }, [eventInfo?.status, eventInfo?.items_sort]);

  const publishedNotEdited = useMemo(
    () => eventInfo?.status === 1 && eventInfo?.reedit_status === 0,
    [eventInfo],
  );

  const publishStatus = useMemo(
    () => (eventInfo?.status === 1 && eventInfo?.reedit_status === 1 ? 0 : eventInfo?.status),
    [eventInfo],
  );

  const publishBtn = useMemo(
    () =>
      [
        // 未发布
        { btn: 'primary', text: '发布', disabled: !!errorInfo?.length },
        // 已发布
        { btn: 'primary', text: '已发布', disabled: true },
        // 发布中
        { btn: 'primary', text: '取消发布' },
        // 发布失败
        { btn: 'primary', text: '发布', disabled: !!errorInfo?.length },
        // 修改发布中
        { btn: 'primary', text: '发布', disabled: true },
        // 修改失败
        { btn: 'primary', text: '发布', disabled: !!errorInfo?.length },
      ][publishStatus || 0],
    [errorInfo, publishStatus],
  );

  const gotoPreview = useCallback(() => {
    dataReport('e#event_navigation#preview_registrationpage_button#click');
    const previewUrl = `${registrationUrl}${!publishedNotEdited ? '?ispreview=1' : ''}`.replace(
      '[eventId]',
      eventId,
    );
    openNewPage(previewUrl);
  }, [eventId, router, publishedNotEdited, registrationUrl]);

  return { status, publishBtn, publishedNotEdited, gotoPreview };
};

export default useEventDetailHooks;
